/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react'
import { useAppSelector, useAppDispatch } from "../../../../redux/hook"
import { Link } from 'react-router-dom';
import { Content, DEFAULT_ZOOM_PERCENTAGE, getBgTemplateSize, isEmptyContent, templateColorPallets } from '../../../../redux/slices/content/contentModels';
import { setContentFromTemplate, setUnselectedSectionIds } from '../../../../redux/slices/content/contentSlice';
import Swal from 'sweetalert2';
import { Position, Template } from '../../../../redux/slices/template/templateModels';
import { defaultThumbnails, defaultTransparentGrids } from '../../../../redux/slices/media/mediaModels';
import { getCorrespondHeight, getCorrespondWidth } from '../../../../redux/slices/editor/editorModels';
import { setZoomPercentage } from '../../../../redux/slices/editor/editorSlice';
import { Tooltip } from '@mui/material';
import { useDeleteTemplateMutation } from '../../../../redux/slices/template/apiTemplateSlice';
import moment from 'moment';
import { useGetAllContentsQuery, useGetAllPlaylistsQuery } from '../../../../redux/slices/content/apiContentSlice';

//----------------------------------------

type Props = {
  className: string,
  template: Template,
  autoLayout? : boolean,
  displayIcon?: boolean,
  active?: boolean,
  ribbonType?: '' | 'recent' | 'favorite' | 'recommended' | 'popular' | 'template' | 'active'
  cardType?: 'portrait' | 'landscape'
}

const ribbonIconBorderColor = {
    'recent'        : ['border-warning' , 'bi bi-stars text-white'],
    'favorite'      : ['border-danger'  , 'bi bi-heart-fill text-white'],
    'recommended'   : ['border-info'    , 'bi bi-hand-thumbs-up-fill text-white'],
    'popular'       : ['border-success' , 'bi bi-star text-white'],
    'template'      : ['border-primary' , 'bi bi-columns text-white'],
    'active'        : ['border-gray-300 opacity-50 w-25px h-25px' , 'bi bi-dot text-white'],
}
//----------------------------------------

// const CardTemplate: React.FC<Props> = ({ className, content, imgSrc, width=0, height=0, autoLayout= true, displayIcon=true, caption='', duration=0, lastUpdated='', ribbonType, cardType = 'landscape' }) => {
const CardTemplate: React.FC<Props> = ({ className, template, ribbonType, autoLayout= true, displayIcon=true, active=false, cardType = 'landscape', }) => {
    //-----------------------------------------
    const dispatch = useAppDispatch()
    const currPersistContent = useAppSelector(state => state.persistor._content.currContent)

    const { data: allContents, isLoading, isFetching } = useGetAllContentsQuery(5, { refetchOnMountOrArgChange: true })
    const { data: allPlaylists, isLoading: isLoadingPlaylist, isFetching: isFetchingPlaylist } = useGetAllPlaylistsQuery()
    // console.log("allContents: ", allContents)
    // console.log("allPlaylists: ", allPlaylists)
    
    const currEditorW = (template.width > template.height ? template.height : template.width) // Original => 720 (Why width always smaller than height?)
    const currEditorH = (template.width > template.height ? template.width : template.height)// Original =>1280 (Why width always smaller than height?)
    
    var currEditorZoomL = 0.162
    var currEditorZoomP = 0.288
    var minHeighL = "51px"
    var minHeighP = "161px"
    if (window.screen.width < 992){
        currEditorZoomL = 0.216
        currEditorZoomP = 0.385
        minHeighL = "68px"
        minHeighP = "215px"
    }
    
    // const [deleteContent] = useDeleteContentMutation();
    // const deleteDeviceHandler = async (cont: Content) => {
    //     Swal.fire({
    //         title: 'Do you really want to delete this content?<h1 style="color:#331168; margin: 15px 0;">'+ cont.user_template_name +'</h1>',
    //         text: "You won't be able to revert this!",
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#331168',
    //         cancelButtonColor: '#E4E6EF',
    //         confirmButtonText: 'Continue',
    //         customClass: {          
    //           cancelButton: 'order-1 left-gap me-5',
    //           confirmButton: 'order-2',
    //           // denyButton: 'order-3',
    //         }
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             deleteContent(cont.user_template_id)                
    //             Swal.fire(
    //                 'Deleted!',
    //                 `'${cont.user_template_name}' has been succesfully deleted.`,
    //                 'success'
    //             )
    //         }
    //     })
    // }

    // console.log("template", template)

    const handleChangeTemplate = (template: Template) =>{
        
        const changeTemplate = (template: Template, notification: boolean = true) => {
            dispatch(setContentFromTemplate({   ...template, 
                user_template_id: currPersistContent.user_template_id,
                user_template_name: currPersistContent.user_template_name,
            })); 
            dispatch(setZoomPercentage(template.width < template.height ? 1: DEFAULT_ZOOM_PERCENTAGE))
            dispatch(setUnselectedSectionIds([]))

            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-right',
                iconColor: 'green',
                customClass: {
                popup: 'colored-toast'
                },
                showConfirmButton: false,
                timer: 2000,
            })
            Toast.fire({
                icon: 'success',
                title: `Template has changed to <span class='text-primary'>${template.template_name}</span>.`,
            })
        }

        // -----------------------------

        if (! isEmptyContent(currPersistContent)){
            Swal.fire({
                title: 'Changing the template will discard<br />any changes made to the current campaign.',
                text : "Do you wish to continue?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#9C258F',
                cancelButtonColor: '#E4E6EF',                
                confirmButtonText: '<span class="mx-5">Continue</span>',                
                cancelButtonText: '<span class="mx-5">Cancel </span>',
                customClass: {          
                cancelButton: 'order-1 left-gap me-5',
                confirmButton: 'order-2',
                }
            }).then((result) => {
                if (result.isConfirmed) {                    
                    changeTemplate(template)                    
                }
            })
        }else{
            changeTemplate(template)
        }        
    }

    // ----------------------------------------
    // const [deleteTemplate] = useDeleteTemplateMutation();
    // const deleteTemplateHandler = async (tmplt: Template) => {
    // // const deleteCustomTemplate = async() =>{
    //     Swal.fire({
    //         title: 'Template id',
    //         input: 'text',
    //         inputAttributes: {
    //             autocapitalize: 'off'
    //         },
    //         showCancelButton: true,
    //         confirmButtonText: 'Delete',
    //         confirmButtonColor: "#ff0000",
    //         showLoaderOnConfirm: true,
    //         preConfirm: (templateId) => {
    //             return templateId
    //         },
    //         allowOutsideClick: () => !Swal.isLoading()
    //     }).then((result) => {
    //         if (result.isConfirmed) {

    //             try {
    //                 console.log(result.value);
    //                 var res = deleteTemplate(result.value);
    //                 let objRes = Object.values(res)
    //                 console.log(objRes)
    //             } catch (error) {
    //                 Swal.fire(
    //                     'Unable to delete template',
    //                     'error'
    //                 )
    //             }
    //         }
    //     })
    // }

    // ----------------------------------------
    const [deleteTemplate] = useDeleteTemplateMutation();
    const deleteTemplateHandler = async (tmplt: Template) => {
        if (! tmplt.in_used){                        
            Swal.fire({
                title: 'Are you sure you want to delete this template?<h1 style="color:#331168; margin: 15px 0;">Template: '+ tmplt.template_name +'</h1>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#9C258F',
                cancelButtonColor: '#E4E6EF',
                confirmButtonText: 'Continue',
                customClass: {          
                    cancelButton: 'order-1 left-gap me-5',
                    confirmButton: 'order-2',
                }
            }).then(async (result) => {
                if (result.isConfirmed) {

                    if(tmplt.template_id) {
                        //1. Delete the current template based on its id
                        // -----------------------------------------------                    
                        try {
                            var res = deleteTemplate(tmplt.template_id)
                            let objRes = Object.values(res)
                            console.log(objRes)


                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'bottom-right',
                                iconColor: 'green',
                                customClass: {
                                popup: 'colored-toast'
                                },
                                showConfirmButton: false,
                                timer: 2000,
                            })
                            Toast.fire({
                                icon: 'success',
                                title: `Template <span class='text-primary'>${tmplt.template_name}</span><br/> is successfully deleted.`,
                            })
                            
                        } catch (error) {
                            Swal.fire(
                                'Unable to delete template',
                                'error'
                            )
                        }
                    }
                }
            })        
        }else{  //Delete In-used Template

            
            // console.log("allContents: ", allContents)
            // console.log("allPlaylists: ", allPlaylists)

            const relatedContents: Content[]= allContents?allContents.filter(cont => cont.template_id && cont.template_id === tmplt.template_id) : [];

            let str = "";
            str += '<h1 class="text-danger" style="margin: 15px 0;">Deleting template: '+ tmplt.template_name +'?</h1>'
            str += '<div class="mt-5 mb-1">This template is currently used by</div>'
            str += '<div class="text-capitalize fw-bold fs-1" style="color:#331168;">'
            relatedContents.forEach((content, i) => {
                str += `${content.user_template_name}${i < relatedContents.length-1 ? ", ":""} `
            })
            str += '</div>'
            str += '<div class="mt-8">All of these campaigns will be deleted as well. '
            str += 'Are you sure?</div>'            
            

            Swal.fire({
                title: str,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#9C258F',
                cancelButtonColor: '#E4E6EF',
                confirmButtonText: 'Continue',
                customClass: {          
                    cancelButton: 'order-1 left-gap me-5',
                    confirmButton: 'order-2',
                }
            }).then(async (result) => {
                if (result.isConfirmed) {

                    // if(tmplt.template_id) {
                    //     //1. Delete the current template based on its id
                    //     // -----------------------------------------------                    
                    //     try {
                    //         var res = deleteTemplate(tmplt.template_id)
                    //         let objRes = Object.values(res)
                    //         console.log(objRes)


                    //         const Toast = Swal.mixin({
                    //             toast: true,
                    //             position: 'bottom-right',
                    //             iconColor: 'green',
                    //             customClass: {
                    //             popup: 'colored-toast'
                    //             },
                    //             showConfirmButton: false,
                    //             timer: 2000,
                    //         })
                    //         Toast.fire({
                    //             icon: 'success',
                    //             title: `Template <span class='text-primary'>${tmplt.template_name}</span><br/> is successfully deleted.`,
                    //         })
                            
                    //     } catch (error) {
                    //         Swal.fire(
                    //             'Unable to delete template',
                    //             'error'
                    //         )
                    //     }
                    // }
                }
            })  
            // Swal.fire({
            //     icon: 'error',
            //     title:  '<span class="text-danger">Unable to delete the in-use template!</span><br/><br/>', 
            //     showConfirmButton: true,
            //     timer: 2000,
            //     timerProgressBar: true
                
            // })        
        }
    }

    // -----------------------------------------
    return (
        <div 
            className={`${className} mb-2 pt-2 pb-1 ${active === true? "bg-gradient-primary rounded bg-opacity-50":" bg-hover-light-primary border border-1 border-secondary border-hover-primary rounded"}`}            
            onClick={()=> { if (!active) handleChangeTemplate(template) }}
        >            
            <div className={`w-100 rounded bg-warning`}>                            
                <div className="card overlay overflow-hidden rounded-0 pe-auto bg-gray-300">
                    <div className="card-body p-0" style={{minHeight: `${minHeighL}`}}>
                        {ribbonType && ribbonIconBorderColor && 
                            <div className={`ribbon ribbon-triangle opacity-75 ribbon-top-start ${ribbonIconBorderColor[ribbonType][0]}`}>
                                <div className="ribbon-icon mt-n5 ms-n6">
                                    <i className={`${ribbonIconBorderColor[ribbonType][1]} fs-3 `}></i>
                                </div>
                            </div>                
                        }     
                        <div 
                            // className={`w-100 overlay-wrapper ribbon ribbon-top ribbon-vertical `}
                            className={`overlay-wrapper ribbon ribbon-top ribbon-vertical `}
                            style={{                                
                                width:  `${(template.height > template.width) && (autoLayout) ? '86px'  : '100%'}`,
                                height: `${(template.height > template.width) && (autoLayout) ? minHeighP : minHeighL}`,
                                background:`url(${defaultTransparentGrids[0]}) no-repeat center center / cover`
                            }}
                        >
                            {template.positions?.
                            slice().sort((a,b)=> a.layer > b.layer ? 1: -1 )
                            .map((position: Position, ind: number) => { 
                                // console.log("position.layer:", position.layer)
                                // ----------------------------------------
                                return(<Fragment key={"pos-"+ind}>
                                    {/* {position.element_type !== "text" && */}
                                        <Fragment key={position.position_id}>                                        
                                            <div                                         
                                                style={{
                                                    background: `no-repeat 
                                                        ${getBgTemplateSize(position.w, position.h)}
                                                        
                                                        ${  position.element_type === "image" ? "url('"+defaultThumbnails[0]+"') "+templateColorPallets[0]
                                                                :   position.element_type === "video" ? "url('"+defaultThumbnails[0]+"') "+templateColorPallets[0]
                                                                    :   position.element_type === "web" ? "url('"+defaultThumbnails[2]+"') "+templateColorPallets[2]
                                                                        :   position.element_type === "text" ? "url('"+defaultThumbnails[3]+"') "+templateColorPallets[3]
                                                                            :   position.element_type === "widget" ? "url('"+defaultThumbnails[4]+"') "+templateColorPallets[4]
                                                                            :   defaultThumbnails[0]
                                                        }                                                  
                                                    `,
                                                    position:'absolute',          
                                                    width: `${getCorrespondWidth (position.w, position.h, currEditorW, currEditorH, (template.height > template.width) && (autoLayout) ? currEditorZoomP : currEditorZoomL)}px`,
                                                    height:`${getCorrespondHeight(position.w, position.h, currEditorW, currEditorH, (template.height > template.width) && (autoLayout) ? currEditorZoomP : currEditorZoomL)}px`,          
                                                    left:  `${getCorrespondWidth (position.x, position.y, currEditorW, currEditorH, (template.height > template.width) && (autoLayout) ? currEditorZoomP : currEditorZoomL)}px`,
                                                    top:   `${getCorrespondHeight(position.x, position.y, currEditorW, currEditorH, (template.height > template.width) && (autoLayout) ? currEditorZoomP : currEditorZoomL)}px`,
                                                }}
                                                className={`${className} border border-1 border-light-primary`}        
                                            >
                                                &nbsp;
                                            </div>   
                                        </Fragment>
                                    {/* } */}
                                </Fragment>)}
                            )}
                        </div>
                        
                        <div className="overlay-layer bg-dark bg-opacity-50 d-block "
                            // onClick={()=> { if (!active) handleChangeTemplate(template) }}
                        >
                            {([2].includes(template.category)) && false &&
                                <div className="text-end" style={{ "height": "35%" }}>
                                    <div className="btn-group py-0 ps-0 pe-2 mx-0" role="group">
                                        {/* <Tooltip arrow placement="bottom" title="Select">
                                            <a  href="#" 
                                                className="btn btn-link text-light hover-elevate-up py-0"
                                                onClick={()=> { handleChangeTemplate(template) }}
                                            >
                                                <i className='fa fa-repeat text-light text-hover-primary p-0'></i>
                                            </a>    
                                        </Tooltip> */}
                                        {/* <Tooltip arrow placement="bottom" title="Duplicate">
                                            <a  href="#" 
                                                className="btn btn-link text-light hover-elevate-up py-0 ms-2"
                                                // onClick={()=> { handleChangeTemplate(template) }}
                                            >
                                                <i className='fa fa-clone text-light text-hover-primary p-0'></i>
                                            </a>    
                                        </Tooltip> */}
                                        {/* {(!template.in_used && !active && [2].includes(template.category)) && <> */}
                                            {/* <Tooltip arrow placement="bottom" title="Edit">
                                                <a  href="#" 
                                                    className="btn btn-link text-light hover-elevate-up py-0 ms-2"
                                                    // onClick={()=> { editTemplateHandler(template) }}
                                                >
                                                    <i className='fa fa-edit text-light text-hover-primary p-0'></i>
                                                </a>    
                                            </Tooltip> */}
                                            <Tooltip arrow placement="bottom" title="Delete">
                                                <a  href="#" 
                                                    className="btn btn-link text-light hover-elevate-up py-0 ms-2"
                                                    onClick={()=> { deleteTemplateHandler(template) }}
                                                >
                                                    <i className='fa fa-trash text-light text-hover-primary p-0'></i>
                                                </a>    
                                            </Tooltip>           
                                        {/* </>}    */}
                                    </div>
                                </div>
                            }
                            {/* <div className='h-100 bg-primary pe-auto'
                            >
                                &nbsp;
                            </div> */}
                        </div> 
                        
                        {/* {template.in_used &&
                            // <div className='position-absolute bottom-0 start-0 mb-n3 ms-n3 bg-light opacity-50 border border-light rounded-circle px-1 shadow-sm'>
                            //     <i className='fa fa-circle text-success opacity-75'></i>
                            // </div>
                            <span className="bullet bullet-dot bg-success h-5px w-5px position-absolute translate-middle bottom-0 start-0 ms-2 opacity-75 animation-blink tooltip-bottom" 
                                data-tooltip-content='In-used Template'
                                style={{marginBottom: "1px"}}></span>
                        } */}
                    </div>
                </div>            
            </div>
            <div className="overflow-hidden position-relative pt-1 px-1 d-flex">                
                <div className="ms-0">
                    <Link 
                        to="#" 
                        className='btn-link btn-link-hover' 
                        title="Resize the browser window to see that its width (max-width) will change at different breakpoints."
                    >
                        <span className={`text-capitalize fs-8 text-truncate mb-0 ${active === true?"text-light fw-bold":"text-muted fw-semibold"}`} style={{ 
                            "maxWidth": "250px",                                
                            "WebkitLineClamp": "2",
                            "WebkitBoxOrient": "vertical",                                 
                            "whiteSpace": "normal",
                            "display": "-webkit-box"
                        }}
                        >                            
                            {template.template_name}
                            {/* {moment(template.updated_at,"YYYY-MM-DD HH:mm:ss").format("MM-DD hh:mmA")} - {template.template_name} */}
                            {/* - {template.template_id} */}
                        </span>
                    </Link>                    
                </div>
                
            </div>
        </div>
    )
}

export { CardTemplate }
